import { Link } from 'react-router-dom';
import type { CareerJobCard as Job } from '../services/careerCatalogueApi';
import { companyPath } from '../utils/company';
import { experienceLevelLabel } from '../utils/experienceLevel';
import { jobDisplayTitle } from '../utils/jobPagePresentation';

export default function CareerJobCard({ job }: { job: Job }) {
  return <Link className="career-job-card" to={companyPath(`job/${encodeURIComponent(job.slug)}`)}>
    <div className="career-card-top"><span className="career-tag">{job.project ? 'Projektstelle' : 'Stellenangebot'}</span>{!job.canApply && <span className="career-tag career-tag-closed">Geschlossen</span>}</div>
    <h3>{jobDisplayTitle(job.title)}</h3>
    <p className="career-card-location">{[job.location, experienceLevelLabel(job.experienceLevel)].filter(Boolean).join(' · ')}</p>
    {job.salary && <p className="career-card-salary">{job.salary}</p>}
    <p className="career-card-summary">{job.metaDescription}</p>
    {job.skills?.length > 0 && <ul className="career-card-skills" aria-label="Technologien">{job.skills.slice(0, 4).map((skill, index) => <li key={`${skill}-${index}`}>{skill}</li>)}</ul>}
    <span className="career-card-link">Stelle ansehen <span aria-hidden="true">↗</span></span>
  </Link>;
}
